const translations = {
  'en-US': {
    'homepage': 'Homepage',
    'toggle_theme': 'Toggle theme',
    'show_menu': 'Show menu',
    'hide_menu': 'Hide menu'
  },
  'pt-BR': {
    'homepage': 'Página inicial',
    'toggle_theme': 'Alternar tema',
    'show_menu': 'Mostrar menu',
    'hide_menu': 'Ocultar menu'
  }
};

export default translations;
